/* ==========================================================================
   Koolseed — Dar ekran şeridi

   Geniş ekranda ızgara olan listeler dar ekranda yatay kaydırmalı şeride
   dönüyor. Bu bileşen o şeride nokta göstergesi ekliyor: kaç SAYFA var,
   hangisindesin ve noktaya basınca o sayfaya gidiliyor. Sayfa = ekrana aynı
   anda sığan kart sayısı; dört kart görünen bir şeritte beş kart iki sayfa.

   Şeridin kendisi normal bir kaydırma kutusu — kaydırma tarayıcının, bu
   yüzden dokunmatikte momentum ve snap doğal çalışıyor.
   ========================================================================== */

(function () {
  'use strict';

  class KsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.dots = this.querySelector('[data-slider-dots]');
      if (!this.track || !this.dots) return;

      this.track.addEventListener('scroll', () => {
        if (this.raf) return;
        this.raf = window.requestAnimationFrame(() => {
          this.raf = 0;
          this.syncActive();
        });
      }, { passive: true });

      this.dots.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-slider-dot]');
        if (!dot) return;
        const index = Number(dot.dataset.sliderDot) * (this.perView || 1);
        const child = this.track.children[Math.min(index, this.track.children.length - 1)];
        if (child) this.track.scrollTo({ left: child.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      });

      this.build();

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => this.build());
        ro.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.build(), { passive: true });
      }
    }

    build() {
      // Taşma yoksa (masaüstünde ızgara) nokta göstergesine gerek yok.
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 4;
      this.dots.hidden = !scrollable;
      this.classList.toggle('is-slider', scrollable);
      if (!scrollable) { this.dots.textContent = ''; return; }

      /* Nokta sayısı kart sayısı kadar değil, SAYFA sayısı kadar: ekranda
         dört kart görünüyorsa beş kartlık şerit iki sayfadır. Kaç kartın
         sığdığı ölçülerek bulunuyor — kart genişliği bölüme göre değişiyor
         (masaüstünde --ks-cols, dar ekranda vw tabanlı). */
      const first = this.track.firstElementChild;
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      this.perView = step > 0
        ? Math.max(1, Math.floor((this.track.clientWidth + gap) / step))
        : 1;

      const count = this.track.children.length;
      const pages = Math.max(1, Math.ceil(count / this.perView));

      if (this.dots.children.length !== pages) {
        this.dots.textContent = '';
        for (let i = 0; i < pages; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ks-mslide__dot';
          dot.dataset.sliderDot = String(i);
          dot.setAttribute('aria-label', String(i + 1));
          this.dots.appendChild(dot);
        }
      }
      this.syncActive();
    }

    syncActive() {
      if (this.dots.hidden) return;
      const pages = this.dots.children.length;
      if (!pages) return;

      /* Etkin sayfayı kaydırma ilerlemesinden buluyoruz. Kartın konumundan
         hesaplamak son sayfada yanıltıyor: şerit sonuna kadar kaydırıldığında
         bile son kart tam sola gelmiyor, çünkü kalan mesafe bir sayfadan az. */
      const max = this.track.scrollWidth - this.track.clientWidth;
      const active = max > 0
        ? Math.min(pages - 1, Math.max(0, Math.round((this.track.scrollLeft / max) * (pages - 1))))
        : 0;

      Array.from(this.dots.children).forEach((dot, i) => {
        const on = i === active;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', String(on));
      });
    }
  }

  if (!customElements.get('ks-slider')) customElements.define('ks-slider', KsSlider);
})();
